import React, { useState, useEffect } from 'react';

/** Exported for first-party telemetry (same key as banner). */
export const BMCS_COOKIE_CONSENT_KEY = 'bmcs_cookie_consent';
const STORAGE_KEY = BMCS_COOKIE_CONSENT_KEY;

type ConsentStatus = 'accepted' | 'declined' | null;

export const CookieConsentBanner: React.FC = () => {
  const [status, setStatus] = useState<ConsentStatus>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY) as ConsentStatus | null;
      if (stored === 'accepted' || stored === 'declined') {
        setStatus(stored);
      }
    } catch {
      // ignore
    }
    setMounted(true);
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      // ignore
    }
    setStatus('accepted');
    window.dispatchEvent(new Event('bmcs-cookie-consent'));
  };

  const handleDecline = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'declined');
    } catch {
      // ignore
    }
    setStatus('declined');
    window.dispatchEvent(new Event('bmcs-cookie-consent'));
  };

  if (!mounted || status !== null) {
    return null;
  }

  return (
    <div
      className="position-fixed bottom-0 start-0 end-0 p-3 bg-white border-top shadow-lg"
      style={{ zIndex: 1050 }}
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="container">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
          <p className="mb-0 small text-muted">
            We would like anonymous, first-party insights about which public pages are viewed so we can improve the site.
            Nothing is recorded unless you accept.
          </p>
          <div className="d-flex gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={handleDecline}
            >
              Decline
            </button>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={handleAccept}
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
